/******************************************************************************
 *
 * Copyright (c) 2019-2022 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Shivam Mishra' <shivam.mishra@wakencode.com>, June 2022
 *
 *****************************************************************************/

import React from "react";
import Icon from "../../assets/image/AccountActivation.svg";
import Footer from "../../footer/Footer";
import { string } from "../../constant/string";
import { useUser } from "../../context/UserContext";

/**
 * Account activation page
 *
 * @param {String} setPage State for current page
 * @returns JSX for account activation  page
 */
const ConfirmActivation = () => {
  //State to set user data from user context
  const { userData, setUserData } = useUser("");
  return (
    <div className="finalPageMain">
      {/* Parant container */}
      <div className="parantContainer">
        {/* Icon for the page */}
        <div>
          <img className="icon" src={Icon} alt="Confirm Activation icon"></img>
        </div>
        {/* Main text on the screen */}
        <div className="mainText">{string.ACCOUNT_ACTIVATED}</div>
        {/* Paragraph text on the screen */}
        <div className="paraText">
          {" "}
          <strong>{string.CONGRATULATIONS}</strong>
          <br />
          <br />
          {localStorage.getItem("mobileNumber") && userData?.userDetails?.email && (
            <>{string.CONFIRMATION_SMS_AND_EMAIL}</>
          )}
          {localStorage.getItem("mobileNumber") && !userData?.userDetails?.email && <>{string.CONFIRMATION_SMS}</>}
          <br />
          <br />
          {localStorage.getItem("mobileNumber") && userData?.userDetails?.email && (
            <>
              {string.CHECK_YOUR} <strong>{string.EMAIL}</strong> {string.FOR} {string.MORE_DETAILS}
            </>
          )}
        </div>
        {/* Button on the screen */}
        <div>
          <form action={process.env.REACT_APP_COMMUNITY_WEB_APP_URL}>
            <button type="submit" className="nextButton">
              {string.LOGINC}{" "}
            </button>
          </form>
        </div>
      </div>
      {/* Footer on the screen */}
      <Footer />
    </div>
  );
};

export default ConfirmActivation;
